<template>
  <el-dialog
    v-if="visible"
    :title="title"
    :visible.sync="visible"
    width="560px"
    append-to-body
    :close-on-press-escape="false"
    :close-on-click-modal="false"
    @closed="handleClosed">
    <el-form
      ref="ruleForm"
      :model="info"
      :rules="rules"
      label-width="100px">
      <el-form-item
        label="账号："
        prop="account">
        <span v-if="info.staffId">{{ info.account }}</span>
        <el-input
          v-else
          v-model="info.account"></el-input>
      </el-form-item>
      <el-form-item
        label="姓名："
        prop="staffName">
        <el-input
          v-model="info.staffName"></el-input>
      </el-form-item>
      <el-form-item
        label="手机号："
        prop="mobile">
        <el-input
          v-model="info.mobile"></el-input>
      </el-form-item>
      <el-form-item
        label="功能："
        prop="functions">
        <checkbox-tree
          v-model="info.functions"
          :treeData="menuNodes"
          nodeKey="funcId"
          :defaultProps="defaultProps" />
      </el-form-item>
    </el-form>
    <span slot="footer">
      <el-button
        :loading="loading"
        @click="toggleModal(false)">
        取 消
      </el-button>
      <el-button
        type="primary"
        :loading="loading"
        @click="handleSubmit">
        确 定
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import CheckboxTree from './checkbox-tree.vue'
import { guid } from '@/utils/index'
import { mapState } from 'vuex'
export default {
  name: 'EditUserModal',
  components: { CheckboxTree },
  props: {
    callback: {
      type: Function
    }
  },
  data() {
    return {
      loading: false,
      visible: false,
      info: {
        staffId: null,
        account: '',
        staffName: '',
        userType: '',
        mobile: '',
        operType: 1,
        functions: []
      },
      menuNodes: [],
      defaultProps: {
        children: 'children',
        label: 'menuName'
      },
      rules: {
        account: [
          { required: true, message: '请输入账号', trigger: 'blur' }
        ],
        staffName: [
          { required: true, message: '请输入姓名', trigger: 'blur' }
        ],
        mobile: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          {
            pattern: /^1[0-9][0-9]\d{8}$/,
            message: '请输入正确的手机号',
            trigger: 'blur'
          }
        ],
        functions: [
          { required: true, message: '请选择功能', trigger: 'change' }
        ]
      }
    }
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.account.userInfo
    }),
    title() {
      const staffId = this.info.staffId
      return (staffId ? '编辑' : '新增') + '账号'
    }
  },
  methods: {
    toggleModal(visible) {
      this.visible = visible
    },
    handleClosed() {
      this.info = {
        staffId: null,
        account: '',
        staffName: '',
        userType: '',
        mobile: '',
        operType: 1,
        functions: []
      }
      this.$refs.ruleForm.resetFields()
    },
    handleSubmit() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.loading = true
          const {
            staffId,
            account,
            staffName,
            functions,
            userType,
            operType,
            mobile
          } = this.info
          const dispatch = this.info.staffId
            ? 'updatestaff'
            : 'addstaff'
          this.$store.dispatch(`account/${dispatch}`, {
            payload: {
              staffId,
              account,
              staffName,
              operType,
              userType: userType || this.userInfo.userType,
              password: '123456',
              mobile,
              functions: functions.filter(item => typeof item === 'number').map(item => ({
                funcId: item
              }))
            },
            success: () => {
              this.loading = false
              this.toggleModal(false)
              this.callback && this.callback()
            },
            fail: () => {
              this.loading = false
            }
          })
        }
      })
    },
    getportalmenutree2orgtype() {
      this.loading = true
      this.$store.dispatch('account/getorgportalmenutree', {
        payload: {
          orgType: 100
        },
        success: res => {
          this.loading = false
          const menu = res.data.menuNodes.filter(i => i.menuId !== 4000)
          menu.forEach(item => {
            item.funcId = item.funcId || `custom-${guid()}`
            const sitem = (item.children || [])
            sitem.forEach(s => {
              s.funcId = s.funcId || `custom-${guid()}`
              const mItem = (s.children || [])
              mItem.forEach(m => {
                m.funcId = m.funcId || `custom-${guid()}`
              })
            })
          })
          this.$set(this, 'menuNodes', menu)
        },
        fail: () => {
          this.loading = false
          this.menuNodes = []
        }
      })
    },
    add(options = {}) {
      this.info = {
        ...this.info,
        account: options.mobilePhone,
        staffName: options.name,
        mobile: options.wxMobilePhone,
        ...options
      }
      this.getportalmenutree2orgtype()
      this.toggleModal(true)
    },
    update(options = {}) {
      this.info = {
        ...this.info,
        ...options
      }
      this.getportalmenutree2orgtype()
      this.toggleModal(true)
    }
  }
}
</script>
